module.exports = __webpack_public_path__ + "static/media/matching-featured-image.8cf3c99f.png";